module.exports = "/_next/static/images/8d5d67cfbe47c440db14551e86696227-prepayment_boleto.png.webp";